/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"


/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  loveInsist: ["postId"],
  loveRequest: ["postId"],
  loveSuccess: ["response"],
  loveFailure: ["response"],
  unloveRequest: ["postId"],
  unloveSuccess: ["response"],
  unloveFailure: ["response"],
})

const MAX_CHANGES = 20

export const LoveTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({ changes: [ ] })

/* ------------- Support ------------- */


const loveFind = (state, action) => {
  const { changes } = state, { postId } = action
  for (let i = 0; i < changes.length; i++) if (changes[i].PostId == postId) return i
  return null
}

const findTimeStamp = (state, timeStamp) => {
  const { changes } = state
  for (let i = 0; i < changes.length; i++) if (changes[i].TimeStamp == timeStamp) return i
  return null
}

/* ------------- Reducers ------------- */

export const loveInsist = (state, action) => {
  const { postId : { postId, relationship = 'Love' } } = action
        , now = Date.now ( )
        , entry = { TimeStamp : now
                  , insisted : true
                  , Relationship : relationship
                  , PostId : postId
                  , State : 'success'
                  , Error : null
                  }
  let newChanges = ([entry].concat(state.changes)).slice(0, MAX_CHANGES); // add to beginning
  return state.merge({ changes: newChanges })
}
// love Post
export const loveRequest = (state, action) => {
  const { postId } = action
  const relationship = 'Love'

  const now = Date.now()
  const index = loveFind(state, action); // do we have a recent similar call?
  if (index !== null && now - state.changes[index].TimeStamp < 2000)
    return state

  const entry = {
    TimeStamp:	  now,
    Relationship: relationship,  // 'Love', 'Unlove'
    PostId:	      postId,
  	State:	      'waiting',
  	Error:	      null
  }
  let newChanges = ([entry].concat(state.changes)).slice(0, MAX_CHANGES); // add to beginning

  return state.merge({ changes: newChanges })
}

function handleFinish(state, action, newChangeState, error) {
  const { response } = action
  const { TimeStamp } = response

  const index = findTimeStamp(state, TimeStamp)
  if (index !== null) {
    const entry      = state.changes[index];
    const newEntry   = entry.merge({State: newChangeState, Error: error}) // clone and update object field
    var newChanges = Object.assign([], state.changes, { [index]: newEntry }) // clone and update index in array

    newChanges = newChanges.filter( o => ! o.insisted )
    return state.merge({ changes: newChanges })
  }

  return state
}

// successful love post
export const loveSuccess = (state, action) => {
  return handleFinish(state, action, 'success', null)
}

// failed love post
export const loveFailure = (state, action) => {
  const { response } = action
  const error = response.data.errors ? response.data.errors[0] : true
  return handleFinish(state, action, 'failure', error)
}

// unlove post
export const unloveRequest = (state, action) => {

  const { postId } = action
  const relationship = 'Unlove'

  const now = Date.now()
  const index = loveFind(state, action)
  if (index !== null && now - state.changes[index].TimeStamp < 2000)
    return state

  const entry = {
    TimeStamp:	  now,
    Relationship: relationship,  // 'Love', 'Unlove'
    PostId:	      postId,
  	State:	      'waiting',
  	Error:	      null
  }
  let newChanges = ([entry].concat(state.changes)).slice(0, MAX_CHANGES); // add to beginning

  return state.merge({ changes: newChanges })
}

// successful unlove post
export const unloveSuccess = (state, action) => {
  return handleFinish(state, action, 'success', null)
}

// failed unlove post
export const unloveFailure = (state, action) => {
  const { response } = action
  const error = response.data.errors ? response.data.errors[0] : true
  return handleFinish(state, action, 'failure', error)
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOVE_INSIST]: loveInsist,
  [Types.LOVE_REQUEST]: loveRequest,
  [Types.LOVE_SUCCESS]: loveSuccess,
  [Types.LOVE_FAILURE]: loveFailure,
  [Types.UNLOVE_REQUEST]: unloveRequest,
  [Types.UNLOVE_SUCCESS]: unloveSuccess,
  [Types.UNLOVE_FAILURE]: unloveFailure,
})
